import styled, { css } from 'styled-components';
import { maxHeight, MaxHeightProps } from 'styled-system';

import { BaseBox } from '../Box';

export const StyledAccordionItem = styled(BaseBox)`
  width: 100%;
  cursor: pointer;
`;

export const StyledAccordionItemContent = styled(BaseBox)<MaxHeightProps & { isActive: boolean; isOpen: boolean }>`
  overflow: hidden;
  max-height: 0px;
  transition: max-height 0.2s linear;
  ${props =>
    props.isActive &&
    props.isOpen &&
    css`
      padding-bottom: 15px;
      ${maxHeight};
    `};
`;
